import { createContext, useContext, useState, useEffect, type ReactNode } from "react";

interface ExpertModeContextType {
  isExpertMode: boolean;
  toggleExpertMode: () => void;
}

const ExpertModeContext = createContext<ExpertModeContextType | undefined>(undefined);

export function ExpertModeProvider({ children }: { children: ReactNode }) {
  const [isExpertMode, setIsExpertMode] = useState<boolean>(() => {
    // Load from localStorage on initial mount
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("expertMode");
      return saved === "true";
    }
    return false;
  });

  useEffect(() => {
    // Save to localStorage whenever mode changes
    localStorage.setItem("expertMode", String(isExpertMode));
  }, [isExpertMode]);

  const toggleExpertMode = () => {
    setIsExpertMode((prev) => !prev);
  };

  return (
    <ExpertModeContext.Provider value={{ isExpertMode, toggleExpertMode }}>
      {children}
    </ExpertModeContext.Provider>
  );
}

export function useExpertMode() {
  const context = useContext(ExpertModeContext);
  if (context === undefined) {
    throw new Error("useExpertMode must be used within an ExpertModeProvider");
  }
  return context;
}

